
































import { Component, Vue } from 'vue-property-decorator';
import mapSettings from '@/settings/MapSettings';
import {
    mapOptionsOff,
    mapOptionsNoControl,
    mapOptionsBlackNoControl
} from '@/settings/MapOptions';
import { MapSetting, Marker, InfoWindow, Coordinate } from '@/models/Retailer';
import { websiteText } from '@/mixins/websiteTexts';

declare var google: any;

@Component
export default class RetailerMap extends Vue {
    $refs!: {
        googleMap: any;
    };

    protected latitude!: string;
    protected longitude!: string;
    protected retailerLink!: string;
    protected retailerName!: string;
    protected retailerAddress!: string;
    protected retailerPhone!: string;

    protected settings!: MapSetting;
    protected options: any;
    protected singleMarker: boolean = false;
    protected isInteractive: boolean = false;
    protected hideInfoWindow: boolean = false;
    protected isDarkTheme: boolean = false;
    protected markers: Marker[] = [];
    protected marker: Marker;
    protected markerCoords: Coordinate = { lat: 0, lng: 0 };
    protected mapMarkerUrl: string;
    protected infoWindow: InfoWindow;

    constructor() {
        super();

        this.settings = mapSettings;
        this.options = mapOptionsNoControl;
        this.mapMarkerUrl = '/ui/assets/marker3.svg';

        this.infoWindow = {
            position: { lat: 0, lng: 0 },
            open: false,
            template: ''
        } as InfoWindow;

        this.retailerLink = this.$attrs['retailer-link'];
        this.retailerName = this.$attrs['retailer-name'];
        this.retailerAddress = this.$attrs['retailer-address'];
        this.retailerPhone = this.$attrs['retailer-phone'];
        this.isInteractive =
            this.$attrs['isInteractive'] === 'True' ? true : false;
        this.isDarkTheme = this.$attrs['dark-theme'] === 'True' ? true : false;
        this.hideInfoWindow =
            this.$attrs['hide-info'] === 'True' ? true : false;
        this.marker = this.getMapMarker();
        // this.$attrs['marker'] = '';
        // this.$attrs['retailer-link'] = '';
        // this.$attrs['retailer-name'] = '';
    }

    mounted() {
        if (this.marker) {
            this.setMarker();
        }
        if (!this.isInteractive) {
            this.options = mapOptionsNoControl;
            if (this.isDarkTheme) {
                this.options = mapOptionsBlackNoControl;
                this.mapMarkerUrl = '/ui/assets/marker3-white.svg';
            }
        }
    }

    private setMarker() {
        this.singleMarker = true;
        this.markerCoords = (JSON.parse(
            this.$attrs.marker
        ) as unknown) as Coordinate;
        this.centerMarker(this.markerCoords);
        this.marker.name = this.retailerName;
        this.marker.address1 = this.retailerAddress;
        this.marker.phone = this.retailerPhone;
        this.marker.url = this.retailerLink;
        if (!this.hideInfoWindow) {
            this.toggleInfoWindow(this.marker);
        }
    }

    private centerMarker(coordinate: Coordinate) {
        this.$refs.googleMap.$mapPromise.then((map: any) => {
            if (coordinate) {
                map.setZoom(9);
                map.setCenter(coordinate);
            }
        });
    }

    private toggleInfoWindow(m: Marker) {
        this.infoWindow.open = true;
        this.infoWindow.template = `<div class="map-infowindow-inner"><div class="map-infowindow-heading">${
            m.name
        }</div><div class="map-infowindow-content">
        <p>${m.address1}</p>
        <a href="tel:${m.phone}" class="bold">${websiteText(
            'retailer.tel'
        )} ${m.phone}</a>
        <a href="${m.url}" target="${
            m.target
        }" class="cta-button map-infowindow-link" data-action="gaet" data-gaet="{&quot;hitType&quot;:&quot;event&quot;,&quot;category&quot;:&quot;Outbound Links&quot;,&quot;action&quot;:&quot;Retailer Web Link&quot;,&quot;label&quot;:&quot;Ballingslöv | Stockholm City&quot;,&quot;value&quot;:null}" target="_blank">${websiteText(
            'retailer.moreinfo'
        )}</a></div></div>`;
        this.infoWindow.position = {
            lat: m.position.lat,
            lng: m.position.lng
        };
    }

    private getMapMarker(): Marker {
        const markerCoords = (JSON.parse(
            this.$attrs.marker
        ) as unknown) as Coordinate;
        const marker: Marker = {
            position: {
                lat: markerCoords.lat,
                lng: markerCoords.lng
            }
        };
        return marker;
    }
}
